import axios from 'axios';
import { diff, patch } from 'virtual-dom';
import createElement from 'virtual-dom/create-element';
import {Spinner} from "spin.js";
import {opts} from "./options/SpinnerOptions";
import { backMsg, showSearchMsg } from "./Update";

function app(initModel, update, view, node) {
    const instance = axios.create({
        withCredentials: true
    } );

    const spinner = new Spinner(opts);
    add(back);
    let model = initModel;
    model = getInitState(model);
    let currentView = view(dispatch, model);
    let rootNode = createElement(currentView);
    node.appendChild(rootNode);
    function dispatch(msg) {
        spinner.stop();
        model = update(msg, model);
        if (!model.successMsg) {
            const addId = model.state === 'detail' && model.detail.queryResult.rapportId ? '?id=' + model.detail.queryResult.rapportId : '';
            if (model.state === history.state.state)
                window.history.replaceState(model, null, "/grundvandsrapport/"+model.state + addId);
            else {
                window.history.pushState(model, null, "/grundvandsrapport/"+model.state + addId);
            }
        }
        httpEffects(dispatch, model, instance, spinner, node);
        download(dispatch, model, instance, spinner, node);
        postHttp(dispatch, model, spinner, node);
        const updatedView = view(dispatch, model);
        const patches = diff(currentView, updatedView);
        rootNode = patch(rootNode, patches);
        currentView = updatedView;
    }
    function back(backModel) {
        spinner.stop();
        model = update(backMsg, backModel);
        const updatedView = view(dispatch, model);
        const patches = diff(currentView, updatedView);
        rootNode = patch(rootNode, patches);
        currentView = updatedView;
    }
}
function getInitState(model) {
    const path = window.location.pathname;
    const parameters = window.location.search;

    const state = path.replace('/grundvandsrapport/', '').replace('/', '');
    const validStates = ['frontPage','search','detail','upload','login', 'orderPin'];
    if (!validStates.includes(state))
        return { ...model, state: 'frontPage' };

    model.state = state;

    if (state === 'detail') {
        const parameters = window.location.search.replace('?', '');
        console.log( 'split:',parameters.split('=')[1] );
        return { ...model, detail: { ...model.detail, loadReportId: parameters.split('=')[1] } };
    }

    return model;
}
function add(back) {
    window.addEventListener("popstate", (event) => {
        if (event.state) {
            back(event.state);
        }
    });
}
function httpEffects(dispatch, model, instance, spinner, node) {
    if (!model.call) {
        return;
    }

    spinner.spin(node);
    const { request, successMsg, errorMsg } = model;
//    instance(request).then(response => dispatch(successMsg(response))).catch(err => dispatch(errorMsg(err)));
    axios(request).then(response => dispatch(successMsg(response))).catch(err => dispatch(errorMsg(err)));
}
function download(dispatch, model, instance, spinner, node) {
    if (!model.download) {
        return;
    }

    spinner.spin(node);
    const { request, successMsg, errorMsg } = model;
    instance(request).then(response => {
        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', model.download); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();

        dispatch(successMsg(response));
    }).catch(err => dispatch(errorMsg(err)));
}

function postHttp(dispatch, model, spinner, node) {
    if (!model.post) {
        return;
    }

    spinner.spin(node);
    let formData = new FormData();
    for (const key of Object.keys(model.upload)) {
        const val = model.upload[key];
        if (key === 'files') {
            model.upload.filesArr.forEach(f => formData.append(f.name, f));
        } else if (val && key != 'oldFiles')
            formData.append(key, val);
    }
    formData.append('FORMULAR_TYPE','GRUNDVANDSRAPPORT');

    if (model.state === 'edit') {
        formData.append('rapportId', model.rapportid);
    }

    const { successMsg, errorMsg, request } = model;

    axios.post(request.url, formData, {
            withCredentials: true,
            headers: { 'Content-Type': 'multipart/form-data' }
        }).
        then(response => dispatch(successMsg(response))).
        catch(err => dispatch(errorMsg(err)));

}

export default app;

